import firebaseApp from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";
import "firebase/firestore";
// import config from '_MAIN/config.json'
// firebaseApp.initializeApp(config.fireBaseConfig)

const config = {
  apiKey: "AIzaSyA637YnyUrFjomGmpRSfUg9GdBjN6KZ-MU",
  authDomain: "app-users-cloud.firebaseapp.com",
  databaseURL: "https://app-users-cloud.firebaseio.com",
  projectId: "app-users-cloud",
  storageBucket: "ga-catastro", //"app-users-cloud.appspot.com",
  messagingSenderId: "1018354841714"
};

firebaseApp.initializeApp(config);
export const dbFB = firebaseApp.database();
export const dbFS = firebaseApp.firestore();
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage();
export const functions = firebaseApp.functions();
